import { Container, Link, List, ListItem, Stack, SvgIcon, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { map } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LogoEgov } from 'src/assets/logo_egov.svg';
// import { ReactComponent as LogoSSV } from 'src/assets/logo_ssv.png';
import { Icons } from '../icons';
import { Logo } from '../logo';
import useStyles from './styles';

export const Footer: ComponentType = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const FOOTER_MENUS = [
    {
      title: 'Контакты',
      titleKey: 'contacts',
      items: [
        { icon: 'Mail', label: 'info@tmbm.uz', path: 'mailto:info@tmbm.uz' },
        { icon: 'Phone', label: '(+998) 71 202-03-31', path: 'tel:+998712020331' },
        { icon: 'Phone', label: '(+998) 71 202-03-32', path: 'tel:+998712020332' },
        { icon: 'Location', label: 'site.address', path: '' },
      ],
    },
    {
      title: 'Мы в соцсетях',
      titleKey: 'weAreInSN',
      items: [
        { icon: 'Facebook', label: 'Facebook', path: 'https://facebook.com/tibtoifa/' },
        { icon: 'Instagram', label: 'Instagram', path: 'https://instagram.com/tibtoifa/' },
        { icon: 'Telegram', label: 'Telegram', path: 'https://t.me/tibtoifa' },
      ],
    },
  ];

  return (
    <Box className={classes.root} bgcolor="primary.dark" py={7.5} color="white" mt="auto">
      <Container>
        <Stack direction="row" spacing={7}>
          {/* 1 */}
          <Stack spacing={4}>
            <Stack
              direction="row"
              spacing={1}
              maxWidth={303}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                window.scroll({ top: 0, behavior: 'smooth' });
              }}
            >
              <Logo sx={{ fontSize: 48 }} />
              <Typography variant="subtitle2">
                {t(
                  'fullProjectNameRaw',
                  'Единая информационная система аттестации и выдачи квалификационных сертификатов'
                )}
              </Typography>
            </Stack>
          </Stack>

          {map(FOOTER_MENUS, (menu, index) => (
            <Stack key={index}>
              <Typography variant="h3">{t(menu.titleKey, menu.title)}</Typography>

              <List className={classes.list} sx={{ maxWidth: 190, py: 0 }}>
                {map(menu.items, (item, idx) => (
                  <ListItem className={classes.listItem} sx={{ p: 0, mt: 2 }} key={idx}>
                    <Stack
                      direction="row"
                      spacing={1}
                      component={Link}
                      href={item.path}
                      color="white"
                    >
                      <SvgIcon component={Icons[item.icon]} viewBox="0 0 24 24" />
                      <Typography
                        variant="body2"
                        component={Stack}
                        direction="row"
                        whiteSpace={item.icon === 'Phone' ? 'nowrap' : 'normal'}
                        sx={{ opacity: 0.8 }}
                      >
                        {t(item.label)}
                      </Typography>
                    </Stack>
                  </ListItem>
                ))}
              </List>
            </Stack>
          ))}

          {/* 4 */}
          <Stack spacing={3} sx={{ maxWidth: 300 }}>
            <Stack direction="row" spacing={1.25}>
              <Link
                href="https://ssv.uz/uz/"
                display={'flex'}
                alignItems={'center'}
                textTransform={'none'}
                underline="none"
                color={'#fff'}
              >
                <img src="/assets/logo_ssv.png" alt="" width={100} />
                <Typography variant="body3" sx={{ maxWidth: 210, ml: 2 }}>
                  {t('SSV', 'Ўзбекистон Республикаси Соғлиқни сақлаш вазирлиги')}
                </Typography>
              </Link>
            </Stack>
            <Stack spacing={2}>
              <Typography variant="body3" component={Stack} sx={{ opacity: 0.6 }}>
                <Box>
                  © {new Date().getFullYear()}{' '}
                  <Link href="https://tibtoifa.ssv.uz/" color="inherit">
                    tibtoifa.ssv.uz
                  </Link>
                </Box>
                <Box>{t('allRightsReserved', 'Все права защищены')}</Box>
              </Typography>

              <Typography variant="caption">
                {t(
                  'useMaterials',
                  'При полном или частичном использовании и цитировании материалов, опубликованных на сайте tibtoifa.egov.uz, ссылка обязательна'
                )}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1.25}>
              <LogoEgov />
              <Typography variant="body3" sx={{ maxWidth: 210 }}>
                {t(
                  'developedBy',
                  'Портал разработан Центром управления проектами цифрового правительства'
                )}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};
